import React from 'react'
import Parser from 'html-react-parser';

export default function GizlilikPolitikasi() {
    const wordContent = `

    <p class=MsoNormal align=center style='mso-margin-top-alt:auto;mso-margin-bottom-alt:
    auto;text-align:center'><b><span style='font-size:20.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>GİZLİLİK POLİTİKASI</span></b><span
    style='font-size:20.0pt;font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Geçerlilik
    Tarihi: Nisan 2025<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><br>
    <span class=GramE>att</span> <span class=SpellE>app</span> uygulamasına hoş
    geldiniz (topluca “biz”, “bizim” veya “bizlere”). <span class=GramE>att</span> <span
    class=SpellE>app</span>, att <span class=SpellE>app</span> yazılımı, mobil
    uygulamaları, web siteleri (topluca “Hizmetler”) sunmaktadır. Bu Gizlilik
    Politikası, Hizmetlerimizi kullanırken bilgilerinizi nasıl topladığımızı,
    kullandığımızı, açıkladığımızı ve koruduğumuzu açıklamaktadır.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>TOPLADIĞIMIZ VERİLER<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Hizmetlerimizi kullanırken farklı şekillerde kişisel
    verileri toplarız. Aşağıda, topladığımız kişisel verilerin kategorileri ve bu
    verileri nasıl topladığımız yer almaktadır.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><i><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Bize
    Sağladığınız Kişisel Veriler</span></i></b><span style='font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Uygulamayı kullandığınızda, doğrudan sağladığınız
    kişisel bilgileri toplarız. Bu veriler, hesabınızın oluşturulması, kullanıcı
    kimlik doğrulaması ve giriş işlemleri gibi Hizmetlerimizi sağlamamıza olanak
    tanır. Kişisel veriler arasında ancak bunlarla sınırlı olmamak üzere e-posta
    adresi, kullanıcı adı, ad, <span class=SpellE>soyad</span>, şifre ve ödeme
    yapmanız durumunda finansal bilgiler bulunmaktadır.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Hizmetlerimizde içeriklerinizi görünür kılmak
    amacıyla, diğer kullanıcılarla olan ilişkinizi de toplarız. Örneğin,
    eklediğiniz veya sildiğiniz arkadaşlarınız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><i><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Sağladığınız
    İçerikler</span></i></b><i><span style='font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></i></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Hizmetlerimizi kullanarak yüklediğiniz veya
    paylaştığınız içerikleri toplarız. Bu içerikler, bunlarla sınırlı olmamak üzere:
    dosyalar, fotoğraflar, videolar, sesler, mesajlar, metinler, başlıklar ve
    bilgiler içerebilir.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Uygulama aracılığıyla paylaştığınız dosyalar, diğer
    kullanıcılarla paylaşılmasını sağlamak amacıyla sunucularımızda geçici olarak
    saklanır. Bu dosyalar, belirli bir süre sonra otomatik olarak silinir.
    Hizmetlerimizi kullanırken yüklediğiniz dosyalar ve belgelerdeki bilgilere,
    yalnızca yasal zorunluluklar nedeniyle veya kamu yetkililerinin geçerli
    talepleri doğrultusunda sınırlı durumlarda erişir veya bu bilgileri kullanırız.
    Belirtilen durumlar haricinde bu içeriklere erişmez ya da bu içerikleri
    kullanmayız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Hizmetlerimizin temel bir özelliği olan konum bazlı
    dosya paylaşımını sağlamak amacıyla, her içeriğe bağlı konum bilgilerini
    toplarız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><i><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Hizmetlerimizi
    Kullanırken Topladığımız Veriler</span></i></b><span style='font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Hizmetlerimizi
    sağlamak için bazı teknik bilgiler toplarız; bunlar verilenlerle sınırlı
    olmamak üzere: IP adresi, cihaz işletim sistemi, cihaz modeli, konum bilgisi
    gibi bilgileri içerir. Hizmetlerimizi kullanabilmeniz için kayıtlı her
    kullanıcıya benzersiz bir kullanıcı kimliği atanır.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Yüklediğiniz
    içeriğe dair, yükleme boyutu, görünürlük (hangi kullanıcıların içeriğinizi
    görebileceğini seçme özelliği) ve süre (içeriğin silinmeden önce geçecek zaman)
    bilgilerini toplarız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Konum
    verilerinizi, dosya paylaşım işlevini etkinleştirmek için toplarız. Bu veriler,
    dosya paylaşım sürecini sağlamak amacıyla geçici olarak saklanır ve dosyalarla
    birlikte belirtilen süre sonunda silinir. Konum servislerine erişim vermemeyi
    tercih ederseniz, harita arayüzü üzerinden konumunuzu belirleyerek
    Hizmetlerimizi kullanabilirsiniz.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Ödemeler
    ve satın alma işlemleriyle ilgili bilgileri, Hizmetlerimizi kullanarak satın
    alma işlemleri gerçekleştirdiğinizde toplarız; bunlar arasında satın alınan
    öğeler, işlem kimliği ve tarihi, fiyat bilgileri bulunmaktadır.&nbsp;<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><i><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Diğer
    Hizmetlerden Aldığımız Veriler<o:p></o:p></span></i></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Ödeme ve Finansal İşlem Sağlayıcılarından,
    Hizmetlerimiz üzerinden yaptığınız satın almalarla ilgili teknik ve satın alma
    bilgileri alırız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Analitik Ölçüm Sağlayıcılarından Hizmetlerimizin ne
    kadar kullanıldığını gösteren bilgiler içeren kullanım bilgilerinde dair
    veriler toplarız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>BİLGİLERİ NASIL VE NEDEN KULLANIRIZ<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>E-posta adresiniz, kullanıcı adınız, adınız ve
    soyadınız gibi kişisel bilgileri, kullanıcıları tanımlamak, hesap oluşturmak ve
    arkadaş ekleyip silme gibi sosyal özellikleri yönetmek için kullanırız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Şifreler de dahil olmak üzere, hesap giriş bilgilerini
    kullanıcıları kimlik doğrulamak ve platformumuza güvenli erişim sağlamak
    amacıyla kullanırız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Satın alma ve işlem detayları gibi finansal bilgileri,
    ücretli hizmetler de dahil olmak üzere Hizmetlerimizin sağlanmasını
    kolaylaştırmak amacıyla işleriz.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Yüklediğiniz içeriklerle ilgili bilgiler, konum, süre
    ve görünürlük ayarlarının, Hizmetlerimizin ana işlevlerini etkinleştirmek ve
    geliştirmek amacıyla kullanırız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>VERİ SAKLAMA<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Sağladığınız kişisel verileri, hesabınız aktif kaldığı
    sürece veya Hizmetlerimizi size sağlamak için gerekli olduğu sürece saklarız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>&quot;Sağladığınız İçerikler&quot; kategorisinde yer
    alan, kullanıcı tarafından oluşturulan içerikler, yüklemede belirtilen
    &quot;Görünürlük&quot; özelliğine göre saklanır. Silme işlemi sonrasında,
    içerikler sunucularımızda bir <span class=GramE>saat süreyle</span> geçici
    olarak kalabilir.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Sunucularımızın veri bütünlüğünü ve erişilebilirliğini
    sağlamak amacıyla düzenli yedeklemeler gerçekleştiririz. Bu yedeklemeler
    kişisel verileri içerebilir ve veri saklama ve güvenlik politikalarımıza uygun
    şekilde güvenli bir şekilde depolanmaktadır. Silinen içeriklerin
    sistemlerimizden tamamen kaldırılması, yedekleme ve acil durum kurtarma
    süreçleri nedeniyle ek olarak 15 gün sürebilir. Bu süre zarfında veriler
    yalnızca sistem bütünlüğünü sağlamak amacıyla saklanmakta olup, aktif
    kullanımda değildir.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Üçüncü taraf hizmet sağlayıcılarla iş birliği yapmamız
    nedeniyle, bu sağlayıcılar kendi politikalarına göre işlem yapmaktadır. Daha
    fazla bilgi için &quot;Verilerinizi Ne Zaman ve Neden Başkalarıyla
    Paylaşıyoruz&quot; başlığına bakınız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>VERİLERİNİZİ NE ZAMAN VE NEDEN
    BAŞKALARIYLA PAYLAŞIRIZ<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Hizmetlerimizi
    size sunabilmek için verileri başkalarıyla paylaşırız. Paylaşılan veriler ve
    nedenleri aşağıda açıklanmıştır.<br style='mso-special-character:line-break'>
    <![if !supportLineBreakNewLine]><br style='mso-special-character:line-break'>
    <![endif]><o:p></o:p></span></p>
    
    <div align=center>
    
    <table class=MsoTableGrid border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none;mso-border-alt:solid windowtext .5pt;
     mso-yfti-tbllook:1184;mso-padding-alt:0cm 5.4pt 0cm 5.4pt'>
     <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:204.1pt'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      mso-border-alt:solid windowtext .5pt;padding:0cm 5.4pt 0cm 5.4pt;height:204.1pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'>Paylaşılan Veriler: </span></b><span style='font-family:"Arial",sans-serif;
      mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
      mso-ligatures:none;mso-fareast-language:TR'>Sağladığınız Kişisel Veriler,
      Sağladığınız İçerikler, Hizmetlerimizi Kullanırken Topladığımız Veriler,
      Diğer Hizmetlerden Aldığımız Veriler<br>
      <b>Alıcılar:</b> Hizmet Sağlayıcıları, Bulut Barındırma, Veri Depolama,
      Teslimat <span class=GramE>Ve</span> Güvenlik<br>
      <b>Neden: </b>Hizmetlerimizi sağlamak amacıyla çeşitli hizmet sağlayıcılarıyla
      iş birliği yapmak zorundayız. Üçüncü taraf hizmetlerinden faydalandığımız
      için, her birinin kendi Gizlilik Politikası bulunabilir. Bu üçüncü taraf
      hizmet sağlayıcılarının Gizlilik Politikalarına aşağıdaki linklerden
      erişebilirsiniz:<o:p></o:p></span></p>
      <ul type=disc>
       <li class=MsoNormal style='color:black;mso-margin-top-alt:auto;mso-margin-bottom-alt:
           auto;mso-list:l0 level1 lfo1;tab-stops:list 36.0pt'><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Google
           Play Hizmetleri</span><span style='font-family:"Arial",sans-serif;
           mso-fareast-font-family:"Times New Roman";color:#0070C0;mso-font-kerning:
           0pt;mso-ligatures:none;mso-fareast-language:TR'>&nbsp;</span><span
           style='font-family:"Arial",sans-serif;color:#0070C0'><a
           href="https://policies.google.com/privacy"><span style='mso-fareast-font-family:
           "Times New Roman";color:#0070C0;mso-font-kerning:0pt;mso-ligatures:none;
           mso-fareast-language:TR'>https://policies.google.com/privacy</span></a></span><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></li>
       <li class=MsoNormal style='color:black;mso-margin-top-alt:auto;mso-margin-bottom-alt:
           auto;mso-list:l0 level1 lfo1;tab-stops:list 36.0pt'><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Expo</span><u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           color:#4E95D9;mso-themecolor:text2;mso-themetint:128;mso-style-textfill-fill-color:
           #4E95D9;mso-style-textfill-fill-themecolor:text2;mso-style-textfill-fill-alpha:
           100.0%;mso-style-textfill-fill-colortransforms:"lumm=50000 lumo=50000";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><span
           style='color:windowtext'>&nbsp;</span></span></u><u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           color:#0070C0;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
           TR'><a href="https://expo.dev/privacy"><span style='color:#0070C0'>https://expo.dev/privacy</span></a></span></u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></li>
       <li class=MsoNormal style='color:black;mso-margin-top-alt:auto;mso-margin-bottom-alt:
           auto;mso-list:l0 level1 lfo1;tab-stops:list 36.0pt'><span class=SpellE><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>RevenueCat</span></span><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>&nbsp;</span><u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           color:#0070C0;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
           TR'><a href="https://www.revenuecat.com/privacy/"><span
           style='color:#0070C0'>https://www.revenuecat.com/privacy/</span></a></span></u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></li>
       <li class=MsoNormal style='color:#0070C0;mso-margin-top-alt:auto;mso-margin-bottom-alt:
           auto;mso-list:l0 level1 lfo1;tab-stops:list 36.0pt'><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
           TR'>Google <span class=SpellE>Firebase</span>&nbsp;</span><u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><a
           href="https://firebase.google.com/support/privacy"><span
           style='color:#0070C0'>https://firebase.google.com/support/privacy</span></a></span></u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></li>
       <li class=MsoNormal style='color:black;mso-margin-top-alt:auto;mso-margin-bottom-alt:
           auto;mso-list:l0 level1 lfo1;tab-stops:list 36.0pt'><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Google
           Cloud Platform&nbsp;</span><u><span style='font-family:"Arial",sans-serif;
           mso-fareast-font-family:"Times New Roman";color:#0070C0;mso-font-kerning:
           0pt;mso-ligatures:none;mso-fareast-language:TR'><a
           href="https://cloud.google.com/terms/cloud-privacy-notice"><span
           style='color:#0070C0'>https://cloud.google.com/terms/cloud-privacy-notice</span></a></span></u><span
           style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
           mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></li>
      </ul>
      </td>
     </tr>
     <tr style='mso-yfti-irow:1;height:12.75pt'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
      padding:0cm 5.4pt 0cm 5.4pt;height:12.75pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'><o:p>&nbsp;</o:p></span></b></p>
      </td>
     </tr>
     <tr style='mso-yfti-irow:2'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
      padding:0cm 5.4pt 0cm 5.4pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'>Paylaşılan Veriler:</span></b><span style='font-family:"Arial",sans-serif;
      mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
      mso-ligatures:none;mso-fareast-language:TR'> Kişisel bilgiler, finansal
      bilgiler ve satın alma verileri<br>
      <b>Alıcılar:</b> Ödeme ve Finansal İşlem Hizmet Sağlayıcıları<br>
      <b>Neden:</b> Ücretli hizmetler sağlamak için ödeme işlemleri
      gerçekleştirdiğinizde, bu bilgileri sağlayıcılarla paylaşırız.<o:p></o:p></span></p>
      </td>
     </tr>
     <tr style='mso-yfti-irow:3'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
      padding:0cm 5.4pt 0cm 5.4pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'><o:p>&nbsp;</o:p></span></b></p>
      </td>
     </tr>
     <tr style='mso-yfti-irow:4'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
      padding:0cm 5.4pt 0cm 5.4pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'>Paylaşılan Veriler: </span></b><span style='font-family:"Arial",sans-serif;
      mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
      mso-ligatures:none;mso-fareast-language:TR'>Sağladığınız Kişisel Veriler,
      Sağladığınız İçerikler, Hizmetlerimizi Kullanırken Topladığımız Veriler,
      Diğer Hizmetlerden Aldığımız Veriler<br>
      <b>Alıcılar: </b>Kanun Hükmü ve Kamu Otoriteleri<br>
      <b>Neden: </b>Yasal yükümlülükleri yerine getirebilmek, hükümet taleplerine
      uyum sağlamak ya da diğer kullanıcıların haklarını ve güvenliğini korumak
      amacıyla, bilgilerinizi erişebilir ve paylaşabiliriz.<o:p></o:p></span></p>
      </td>
     </tr>
     <tr style='mso-yfti-irow:5'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
      padding:0cm 5.4pt 0cm 5.4pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'><o:p>&nbsp;</o:p></span></b></p>
      </td>
     </tr>
     <tr style='mso-yfti-irow:6;mso-yfti-lastrow:yes'>
      <td width=604 valign=top style='width:453.1pt;border:solid windowtext 1.0pt;
      border-top:none;mso-border-top-alt:solid windowtext .5pt;mso-border-alt:solid windowtext .5pt;
      padding:0cm 5.4pt 0cm 5.4pt'>
      <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><b><span
      style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'>Paylaşılan Veriler:</span></b><span style='font-family:"Arial",sans-serif;
      mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
      mso-ligatures:none;mso-fareast-language:TR'> Kullanıcı adı, Ad, <span
      class=SpellE>Soyad</span>, E-posta (Kişisel Verileriniz)<br>
      İçerik Adı, Süre, Görünürlük, Konum, Dosyalar ve Belgeler (Sağladığınız
      İçerikler)<br>
      İçerik Büyüklüğü (Hizmetlerimizi Kullanırken Topladığımız Veriler)<br>
      Satın Alma Bilgileri (Diğer Hizmetlerden Aldığımız Veriler)<br>
      <b>Alıcılar: </b>Diğer Kullanıcılar<br>
      <b>Neden:</b> Hizmetlerimizin düzgün işleyebilmesi için, içerik
      yüklediğinizde veya diğer kullanıcılarla</span><span style='font-size:14.0pt;
      font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
      color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:
      TR'> </span><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
      "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
      mso-fareast-language:TR'>etkileşime geçtiğinizde, bazı bilgilerinizi diğer
      kullanıcılarla paylaşırız.<o:p></o:p></span></p>
      </td>
     </tr>
    </table>
    
    </div>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>GÜVENLİK</span></b><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'><o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Bilgilerinizin gizliliğini korumaya kararlıyız.
    İşlediğimiz ve sakladığımız bilgileri korumak için fiziksel ve elektronik
    güvenlik önlemleri alırız. Bu bilgilerin erişimi, yalnızca uygulamayı
    çalıştırmak, geliştirmek veya geliştirmek için yetkili çalışanlar ve
    yüklenicilerle sınırlıdır. <o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Lütfen işlediğimiz ve sakladığımız bilgiler için güçlü
    güvenlik önlemleri sağlamaya çalıştığımızı, ancak hiçbir güvenlik sisteminin
    tüm olası güvenlik ihlallerine karşı tam koruma garantisi veremeyeceğini
    unutmayınız.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>HAKLARINIZ<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Kişisel verileriniz üzerinde daha fazla kontrol
    sağlamak için size çeşitli haklar tanınmaktadır. Bunlar arasında verilerinizi
    erişme hakkı, verilerinizin işlenme şekli hakkında bilgi edinme hakkı,
    verilerinizin yanlış veya eksik olan bilgilerini düzeltme hakkı yer alır.
    Ayrıca, verilerinizin silinmesini talep etme veya belirli koşullar altında
    işlenmesini kısıtlama hakkınız bulunmaktadır. Veri taşınabilirliği hakkınız
    sayesinde kişisel verilerinizi yaygın bir formatta alabilir ve başka bir
    denetçiye transfer edebilirsiniz. Ayrıca, herhangi bir zamanda verdiğiniz
    rızayı geri çekebilir ve haklarınızın ihlal edildiğini düşündüğünüzde, bize
    ulaşabilirsiniz. Son olarak, verilerinizin nasıl toplandığı, kullanıldığı ve
    paylaşıldığı hakkında bilgi edinme hakkına sahipsiniz.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>ÇOCUKLAR<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Hizmetlerimiz, çocuklar için tasarlanmamıştır ve
    yalnızca 16 yaş ve üzerindeki bireyler tarafından kullanılabilir.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>BU GİZLİLİK POLİTİKASINDAKİ
    DEĞİŞİKLİKLER<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'>Bu Gizlilik Politikasını zaman zaman
    güncelleyebiliriz. Değişiklikleri bildirmek amacıyla yeni Gizlilik Politikasını
    uygulamamızda yayımlayacağız. Bu Gizlilik Politikasını düzenli olarak gözden
    geçirmeniz önerilir.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span style='font-family:"Arial",sans-serif;mso-fareast-font-family:
    "Times New Roman";color:black;mso-font-kerning:0pt;mso-ligatures:none;
    mso-fareast-language:TR'><o:p>&nbsp;</o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><b><span style='font-size:14.0pt;font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>BİZE ULAŞIN<o:p></o:p></span></b></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto'><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'>Herhangi
    bir sorunuz ya da isteğiniz varsa, şu adreslerden bizimle iletişime
    geçebilirsiniz:<br>
    <span class=SpellE>Email</span>: legal@att-app.com<br>
    Fiziksel adres: PK/15 Şişli PTT Şişli / Türkiye<o:p></o:p></span></p>
    
    <p class=MsoNormal style='mso-margin-top-alt:auto;mso-margin-bottom-alt:auto;
    text-align:justify'><span class=GramE><span style='font-family:"Arial",sans-serif;
    mso-fareast-font-family:"Times New Roman";color:black;mso-font-kerning:0pt;
    mso-ligatures:none;mso-fareast-language:TR'>att</span></span><span
    style='font-family:"Arial",sans-serif;mso-fareast-font-family:"Times New Roman";
    color:black;mso-font-kerning:0pt;mso-ligatures:none;mso-fareast-language:TR'> <span
    class=SpellE>app</span> uygulamasını kullanarak, bu Gizlilik Politikasının
    şartlarını kabul etmiş olursunuz.<o:p></o:p></span></p>
    
    <p class=MsoNormal style='text-align:justify'><span style='font-family:"Arial",sans-serif'><o:p>&nbsp;</o:p></span></p>
    
    `
    return (
        <div className='lg:w-1/2 p-2 text-sm my-5'>
            {Parser(wordContent)}

        </div>
    )
}
